import { render, staticRenderFns } from "./formPenilaianPelaksanaanPelakuUsaha.vue?vue&type=template&id=89c9926e&scoped=true&"
import script from "./formPenilaianPelaksanaanPelakuUsaha.vue?vue&type=script&lang=js&"
export * from "./formPenilaianPelaksanaanPelakuUsaha.vue?vue&type=script&lang=js&"
import style0 from "./formPenilaianPelaksanaanPelakuUsaha.vue?vue&type=style&index=0&id=89c9926e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c9926e",
  null
  
)

export default component.exports